import ReactDOM from 'react-dom';
import App from './app';
import configureStore from '../shared/configureStore';
import shim from './utils/shim';

shim();

const globalObject = global || window;
const { document, reduxState } = globalObject;
const store = configureStore(reduxState);

function renderApplication() {
  ReactDOM.render(<App store={store} />, document.getElementById('app'));
}

renderApplication();
